module.exports = __webpack_public_path__ + "img/Alvaro_Maia@2x.746c13e6.png";